import { environment } from "../utility/environment"

const txtIdMapper = [
  "F0000102",
  "F0000201",
  "F0000202",
  "F0000203",
  "F0000204",
  "F0010101",
  "F0010102",
  "F0010103",
  "F0010104",
  "F0020102",
  "F0020201",
  "F0020202",
  "F1010101",
  "F1010102",
  "F1010201",
  "F1010202",
  "F1010203",
  "F1010204",
  "F1010205",
  "F1010301",
  "F1010302",
  "F1010303",
  "F1010304",
  "F1010311",
  "F1010312",
  "F1010313",
  "F1010321",
  "F1010322",
  "F1010323",
  "F1010324",
  "F1010325",
  "F1010326",
  "F1010327",
  "F1010328",
  "F1010329",
  "F1010330",
  "F1010331",
  "F1010332",
  "F1010333",
  "F1010334",
  "F1010341",
  "F1010342",
  "F1010343",
  "F1010344",
  "F1010351",
  "F1010361",
  "F1010362",
  "F1010363",
  "F1010364",
  "F1010365",
  "F1010372",
  "F1010373",
  "F1010374",
  "F1020101",
  "F1020102",
  "F1020201",
  "F1040101",
  "F1040102",
  "F1040103",
  "F1040203",
  "F1050301",
  "F1050302",
  "F2010101",
  "F2010102",
  "F2010104",
  "B1010103",
  "F2010201",
  "F2010202",
  "F2010203",
  "F2010204",
  "F2010205",
  "F2010206",
  "F2020101",
  "F2020102",
  "F2020103",
  "F2020104",
  "F2020105",
  "F2020106",
  "F2020107",
  "F2020108",
  "F2020201",
  "F2020202",
  "DPB0127" ,
  "DPB0128" ,
  "B0000101",
  "B0000102",
  "B1000001",
  "B1000002",
  "B1000101",
  "B1010101",
  "B1010102",
  "B1010103",
  "B1010104",
  "B1010201",
  "B1010202",
  "B1010203",
  "B1010204",
  "B1020101",
  "B1020102",
  "B1020103",
  "B1020104",
  "B1020105",
  "B2010101",
  "B2010102",
  "B2010103",
  "B2010104",
  "B2010105",
  "B2010201",
  "B2010202",
  "B2010203",
  "B2010204",
  "B2010205",
  "B2010206",
  "B2010301",
  "B2010302",
  "B2020101",
  "B2020102",
  "B2020103",
  "B2020104",
];

//   API path flag 預設為true 回傳正常路徑
  export const getTxtIdMapperPath = (txtId, before=false) => {
    let isBefore = before?'/before':''
    return `${environment.contextVersion}/${environment.basicModule}/`+txtId?.toLowerCase()+isBefore;
  
  }
  